import { combineReducers } from 'redux'
import { reducer as session } from 'redux-simple-auth'

export default combineReducers({
  session
})



// WEBPACK FOOTER //
// ./src/reducers/index.js